import React from 'react'
import './style.css'

function PanggilOff() {
    return (
        <div className='container-panggil'>
            <div className='button-panggil'><p>Panggil</p></div>
        </div>
    )
}

export default PanggilOff



// WEBPACK FOOTER //
// ./src/pages/Components/Button-Panggil/PanggilOff.js